import { prefersReducedMotion } from '@theme/utilities';

// Fraction of normal scroll speed the element should appear to move at.
// 0.85 == lags behind the rest of the page by 15%.
const SPEED = 0.85;

/**
 * Nudges itself vertically by a fraction of how far the page has scrolled since it
 * connected, so it appears to scroll slower than the content around it. Driven by
 * window.scrollY (not getBoundingClientRect, which would reflect this element's own
 * transform and compound on itself frame over frame).
 */
class WhyTriglyParallax extends HTMLElement {
  /** @type {number | null} */
  #rafId = null;

  /** @type {number} */
  #initialScrollY = 0;

  connectedCallback() {
    if (prefersReducedMotion()) return;

    this.#initialScrollY = window.scrollY;
    window.addEventListener('scroll', this.#handleScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#handleScroll);

    if (this.#rafId !== null) {
      cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
  }

  #handleScroll = () => {
    if (this.#rafId !== null) return;

    this.#rafId = requestAnimationFrame(() => {
      this.#rafId = null;
      this.#update();
    });
  };

  #update = () => {
    const scrolled = window.scrollY - this.#initialScrollY;

    this.style.setProperty('--parallax-y', `${(scrolled * (1 - SPEED)).toFixed(2)}px`);
  };
}

if (!customElements.get('why-trigly-parallax')) {
  customElements.define('why-trigly-parallax', WhyTriglyParallax);
}
